module.exports = __webpack_public_path__ + "img/coins-1.ca1ff410.png";